import {
  type PlayerPayload,
  Status,
  VerificationPayloadName,
  VerificationPayloadStatus,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

type Verifications = PlayerPayload['verifications']

export const getAutomaticAgeVerification = (verifications: Verifications) =>
  verifications.find(
    (verification) => verification.name === VerificationPayloadName.AutomaticAgeVerification,
  )

export const getIdologyUrl = (verifications: Verifications) =>
  verifications.find((verification) => verification.manualVerificationUrl)?.manualVerificationUrl

export const getIsAutomaticAgeVerificationPending = (verifications: Verifications) =>
  getAutomaticAgeVerification(verifications)?.status === VerificationPayloadStatus.Pending

export const getIsPlayerRegistered = (status: Status) => status === Status.Registered

export const getIsPlayerVerified = (status: Status) => status === Status.Verified

export const getManualAgeVerification = (verifications: Verifications) =>
  verifications.find(
    (verification) => verification.name === VerificationPayloadName.ManualAgeVerification,
  )

export const getShouldVerifyEmail = (verifications: PlayerPayload['verifications']) => {
  const status = verifications.find(
    ({ name }) => name === VerificationPayloadName.EmailVerification,
  )?.status

  return (
    status !== VerificationPayloadStatus.NotStarted && status !== VerificationPayloadStatus.Success
  )
}

export const getIsEmailNotVerified = (verifications: PlayerPayload['verifications']) => {
  const status = verifications.find(
    ({ name }) => name === VerificationPayloadName.EmailVerification,
  )?.status

  return status !== VerificationPayloadStatus.Success
}

export const getShouldVerifyPhone = (status: PlayerPayload['phone']['status']) =>
  status !== VerificationPayloadStatus.Success && status !== VerificationPayloadStatus.NotSupported

export const getHasManualAgeVerification = (verifications: Verifications) => {
  const needsManualVerification = !!getManualAgeVerification(verifications)
  if (needsManualVerification) return true

  const idologyVerificationStatus = verifications.find(
    (verification) => verification.name === VerificationPayloadName.IdUploadAgeVerification,
  )?.status

  if (!idologyVerificationStatus) return false

  return [VerificationPayloadStatus.Failure, VerificationPayloadStatus.Pending].includes(
    idologyVerificationStatus,
  )
}
